import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Button, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Room,} from '@material-ui/icons';
import { useImagePath } from '../hooks/paths';

const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
    margin: theme.spacing(3, 0, 0, 0),
    padding: theme.spacing(3, 0, 0, 0),
    // backgroundColor:'red'
  },

  footer: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.grey,
    minHeight: 100
  },

  row: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor:'green'
  },

  content: {
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    width: "100%",
    margin: theme.spacing(4, 1, 0, 1),
    [theme.breakpoints.up('md')]: {
      width: "80%",
      margin: theme.spacing(2, 1, 0, 1),
    },

    // backgroundColor:'yellow'
  },


  title: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'center',
    textTransform: 'uppercase',
    color: theme.palette.text.disabled
  },

  address: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'center',
    color: theme.palette.text.disabled
  },

  powered: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    color: theme.palette.text.disabled,
    margin: theme.spacing(-1, 0, 0, 0),
  },

  logo: {
    width: 16,
    margin: theme.spacing(0, 0.5, 0, 0.5),
  },

  wikimenu: {
    fontFamily: "'Baloo 2', cursive",
    padding: 0,
    margin: 0,
    color: theme.palette.text.disabled
  },

  end: {
    minHeight: 100,
  }

}));


export default function Footer(props) {
  const classes = useStyles();
  const { location, isTakingOrder, padding,linkMessage } = props
  const imagePath = useImagePath(); 
  const logoUrl = `${imagePath}/ic_wim.svg`;
 

  return (

    <div className={classes.root}>
      <div className={classes.footer}>


        <Grid item xs={12} sm={7} >
          <div className={classes.row}>
            <div className={classes.content}>

              {!isTakingOrder &&
                <div className={classes.title}>
                  <Typography variant="subtitle2">{location.name}</Typography>
                </div>
              }
              {!isTakingOrder && location.address && 
                <div className={classes.address}>
                  <Room fontSize='small' color='disabled' />
                  <Typography mx={0.3} variant="caption" align='center'>{location.address}</Typography>
                </div>
              }
              <div className={classes.powered}>
                <Typography variant="caption">{linkMessage}</Typography>
                <Button
                  variant="text"
                  color="text"
                  onClick={() => window.open("https://wim.to/", "_blank")}
                >
                  <img className={classes.logo} src={logoUrl} alt={"logo"} />
                  <p className={classes.wikimenu}>WIM</p>
                </Button>
              </div>
              {isTakingOrder && padding &&
                <div className={classes.end}></div>
              }

            </div>
          </div>
        </Grid>

      </div>
    </div>
  )
}